module.exports = __webpack_public_path__ + "static/img/WhatsApp Image 2024-11-03 at 22.16.14.07741473.jpg";